<template>
  <table-layout :class="[baseCss]" x-align="center" y-align="middle">
    <row v-if="buttons">
      <cell>
        <icon :color="color" :size="iconSize" :color-lightness="colorLightness" @click="setValueUp(value)" name="chevron-up" :class="[disabled ? 'disabled' : 'cursor-pointer']" :icon-provider="iconProvider" />
      </cell>
      <cell :class="[`${baseCss}-separator`]">&nbsp;</cell>
    </row>
    <row>
      <cell>
        <table-layout x-align="center" y-align="middle">
          <row>
            <cell :class="[`${baseCss}-separator`, setTextColor()]" v-html="showSeparator ? separator : '&nbsp;'" />
            <cell>
              <text-field readonly :disabled="disabled" :color="color" :color-lightness="colorLightness" @keydown.prevent.up="setValueUp(value)" @keydown.prevent.down="setValueDown(value)" v-model="value" />
            </cell>
          </row>
        </table-layout>
      </cell>
    </row>
    <row v-if="buttons">
      <cell>
        <icon :color="color" :size="iconSize" :provider="iconProvider" :color-lightness="colorLightness" @click="setValueDown(value)" name="chevron-down" :class="[disabled ? 'disabled' : 'cursor-pointer']" :icon-provider="iconProvider" />
      </cell>
      <cell :class="[`${baseCss}-separator`]">&nbsp;</cell>
    </row>
  </table-layout>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'TimePickerSpinner',
  mixins: [
    methods
  ],
  data () {
    return {
      value: 0,
      baseCss: this.componentBaseCss('time-picker-spinner', [])
    }
  },
  watch: {
    disabled () {
      if (this.disabled) {
        this.setValue()
      }
    }
  },
  props: {
    initialState: {
      type: [
        Number,
        String
      ]
    },
    buttons: {
      type: Boolean
    },
    iconUp: {
      type: String
    },
    iconDown: {
      type: String
    },
    iconSize: {
      type: Number
    },
    disabled: {
      type: Boolean
    },
    hourCycle: {
      type: String
    },
    iconProvider: {
      type: String
    },
    segment: {
      type: String
    },
    showSeparator: {
      type: Boolean
    },
    separator: {
      type: String,
      default: ':'
    },
    color: {
      type: String
    },
    colorLightness: {
      type: Number
    }
  },
  mounted () {
    this.onMounted()
  },
  methods: {
    onMounted () {
      const hourCycle = this.hourCycle
      this.value = this.initialState
      this.$nextTick(() => {
        this.setValue(hourCycle && ['h12', 'h24'].includes(hourCycle) ? this.value === 0 ? 1 : this.value : this.value)
      })
    },
    setValueUp (value) {
      this.setValue(this.segment !== 'am/pm' ? parseInt(value) + 1 : this.value === 'am' ? 'pm' : 'am')
    },
    setValueDown (value) {
      this.setValue(this.segment !== 'am/pm' ? parseInt(value) - 1 : this.value === 'am' ? 'pm' : 'am')
    },
    setValue (value = this.segment === 'am/pm' ? this.value : 0) {
      const segment = this.segment
      const data = {}
      const parent = this.$parent.$parent.$parent.$parent.$parent.$parent
      const spinners = parent.$refs['spinner']
      let hourCycle = this.hourCycle
      if (this.disabled) {
        return
      }
      if (hourCycle) {
        hourCycle = parseInt(this.hourCycle.replace('h', ''), 10)
      }
      switch (segment) {
        case 'hours':
          switch (hourCycle) {
            case 11:
            case 23:
              this.value = value > -1 ? value <= hourCycle ? value : 0 : hourCycle
              break
            case 12:
            case 24:
              if (value <= hourCycle && value !== 0) {
                this.value = value
              } else if (value > hourCycle) {
                this.value = 1
              } else if (value === 0) {
                this.value = hourCycle
              }
              break
          }
          break
        case 'minutes':
        case 'seconds':
          this.value = value === -1 ? value = 58 - value : value === 60 ? '00' : value // value === -1 ? value = 58 - value : value
          break
        case 'am/pm':
          this.value = value
          break
      }
      if (segment !== 'amp/pm' && parent.padZero) {
        this.value = String(this.value).padStart(2, '0')
      }
      spinners.forEach(spinner => {
        data[spinner.segment] = spinner.value
      })
      if (!Object.values(data).includes(null)) {
        parent.$emit('input', data)
      }
      this.$el.querySelector('input').focus()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/time-picker/time-picker-spinner.vue